import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const DeviceFixFaq = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('how_start_fix'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div style={{ width: '100%' }}>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('service_message')}</span>
            </div>
        </div>
    </div>
}

export default DeviceFixFaq